import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  // BehaviorSubject to track online status
  private onlineStatus = new BehaviorSubject<boolean>(navigator.onLine);

  constructor() {
    // Listen for online and offline events
    window.addEventListener('online', () => this.updateOnlineStatus(true));
    window.addEventListener('offline', () => this.updateOnlineStatus(false));
  }

  private updateOnlineStatus(status: boolean) {
    this.onlineStatus.next(status); // Notify all subscribers about the change
  }

  // Method to get the current status as an observable
  getOnlineStatus() {
    return this.onlineStatus.asObservable(); // Observable for subscription
  }

  // Synchronous method to get the current online status
  isOnline(): boolean {
    return navigator.onLine;
  }
}
